import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Store } from 'lucide-react';

export default function StoreProfile() {
  const { id } = useParams();
  const [store, setStore] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStore = async () => {
      try {
        const [storeRes, productsRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/stores/${id}`),
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/products?seller_id=${id}`)
        ]);
        setStore(storeRes.data);
        setProducts(productsRes.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchStore();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!store) return <div>Store not found</div>;

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <div className="bg-stone-900 text-white rounded-3xl p-12 mb-12 text-center relative overflow-hidden">
        <div className="absolute inset-0 bg-orange-600/10 pattern-grid-lg opacity-20"></div>
        <div className="relative z-10">
          <div className="w-24 h-24 bg-white rounded-full mx-auto mb-6 flex items-center justify-center text-stone-900">
            <Store size={40} />
          </div>
          <h1 className="text-5xl font-bold mb-4 font-heading">{store.store_name || store.name}</h1>
          <p className="text-stone-300 text-lg max-w-2xl mx-auto">
            Welcome to our artisan workshop. Every piece is handcrafted with love and tradition.
          </p>
        </div>
      </div>

      <h2 className="text-3xl font-bold mb-8 text-stone-900">Our Collection</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {products.map(product => (
          <Link key={product.id} to={`/product/${product.id}`} className="group relative bg-white rounded-2xl overflow-hidden border border-stone-100 shadow-sm hover:shadow-xl transition-all">
             <div className="aspect-square overflow-hidden bg-stone-100">
                <img 
                  src={product.image_url} 
                  alt={product.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <h3 className="font-bold text-lg">{product.title}</h3>
                <p className="text-primary font-bold mt-2">{product.price} DZD</p>
              </div>
          </Link>
        ))}
      </div>
      
       {products.length === 0 && <p className="text-center text-stone-500">This artisan hasn't listed any products yet.</p>}
    </div>
  );
}
